import { CallHandle, CallState, HubMethods } from '../../../../local-call';
import { HandleSocketMessageFns } from '../model/handle-socket-message-fns.model';

interface Msg {
    hubMethod: string;
    payload: any;
}

export function handleLocalCallSocketMessage(
    msg: Msg,
    fns: HandleSocketMessageFns,
): void {
    switch (msg.hubMethod) {
        case HubMethods.OnRetrieveCurrentCall:
            onRetrieveCurrentCall(msg.payload, fns);
            break;
        case HubMethods.OnCallState:
            onCallState(msg.payload, fns);
            break;
    }
}

export function onRetrieveCurrentCall(
    payload: CallHandle | null,
    fns: HandleSocketMessageFns,
): void {
    fns._meetingStarted();
    const initialTranscriptState = payload?.stateHistory?.find(
        (e) => e.state === CallState.InitialTranscriptStreamed,
    );
    if (initialTranscriptState != null) {
        fns._initialTranscriptStreamed();
    }
}

export function onCallState(
    payload: CallState | null,
    fns: HandleSocketMessageFns,
): void {
    fns._rememberStatusChange(payload);
    switch (payload) {
        case CallState.Started:
            fns._reset();
            fns._meetingStarted();
            break;
        case CallState.InitialTranscriptStreamed:
            fns._initialTranscriptStreamed();
            break;
        case CallState.Ended:
            fns._meetingEnded();
            break;
    }
}
